import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { Observable, ReplaySubject, tap,of } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { environment } from 'environments/environment';
import {  catchError, startWith } from 'rxjs/operators';
import { UserService } from 'app/services/user.service';
const NAV_KEY = 'app.navigation.v1';
@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    defaultMenu : any = []
    /**
     * Constructor
     */
    constructor(
                    private _httpClient: HttpClient
                    ,private _userService: UserService,
                )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>{
        return this._httpClient.get<any>('api/common/navigation')
        .pipe(
            tap((navigation) => {
                this._navigation.next(navigation);
                this.writeCache(navigation);
            })
            ,catchError(async (err: HttpErrorResponse) => {
                console.log("Error Menu handler...")
                var _appToken,_uuidEmployee
                _appToken     = localStorage.getItem('appToken');
                _uuidEmployee = localStorage.getItem('uuidEmployee');
                try{
                    const { menu } = await this._userService.getMenu(_appToken,_uuidEmployee);
                    const fallback: any = {default:menu}
                    this._navigation.next(fallback);
                    console.log("handler OK")
                    return of(fallback);
                }catch(e){
                    console.log("handler Err")
                    console.log(e)
                    const fallback: any = this.readCache() ?? this.defaultMenu;
                    this._navigation.next(fallback);
                    return of(fallback);
                }

              })
        );
        // return this._httpClient.get<any>(environment.endPoints.userMenu).pipe(
        //     tap((navigation) => {
        //         console.log(navigation);
        //         this._navigation.next(navigation);
        //     })
        // );
    }

    private isNavigation(val: any): val is Navigation {
        return (
          val &&
          typeof val === 'object' &&
          Array.isArray(val.default) &&
          Array.isArray(val.compact) &&
          Array.isArray(val.futuristic) &&
          Array.isArray(val.horizontal)
        );
      }
    


    private readCache(): Navigation | null {
        try {
          const raw = localStorage.getItem(NAV_KEY);
          if (!raw) return null;
    
         
          const parsed = JSON.parse(raw);
          if (this.isNavigation(parsed)) {
            return parsed;
          }
          
    
          // Si hay basura vieja (e.g., array), la limpiamos para evitar futuros errores
        //  localStorage.removeItem(NAV_KEY);
         
        } catch(e) {
          return null;
        }
    }
    
      private writeCache(nav: Navigation): void {
        try {
            localStorage.setItem(NAV_KEY, JSON.stringify(nav));
          } catch {
            /* storage lleno/bloqueado: ignorar */
          }    
}
}
